import { render, staticRenderFns } from "./VInputNumber.vue?vue&type=template&id=6aead97c&"
import script from "./VInputNumber.vue?vue&type=script&lang=ts&"
export * from "./VInputNumber.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports